import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  data:any;
  constructor(
    private authService:AuthService
  ) { }

  ngOnInit(): void {
    this.getTermsConditions();
  }


  getTermsConditions(){
    this.authService.termsCondition().then((res)=>{
      if(res){
        this.data=res
      }
      
    })
  }

}
